<template>
  <div
    class="location-empty-state"
    :class="`location-empty-state--${variant}`"
    :data-testid="rootTestId"
  >
    <div class="location-empty-state__icon-wrap" aria-hidden="true">
      <div class="location-empty-state__icon-circle">
        <img
          :src="iconSrc"
          alt=""
          class="location-empty-state__icon"
          data-testid="setup-location__empty-icon"
        />
      </div>
    </div>

    <h3 class="location-empty-state__title" data-testid="setup-location__empty-title">
      {{ title }}
    </h3>

    <p class="location-empty-state__description" data-testid="setup-location__empty-description">
      {{ description }}
    </p>

    <v-btn
      v-if="showAction"
      color="primary"
      class="location-empty-state__action text-none white--text"
      :disabled="actionDisabled"
      :data-testid="actionTestId"
      @click="$emit('action')"
    >
      <v-icon v-if="variant === 'no-locations'" left small>mdi-plus</v-icon>
      {{ actionLabel }}
    </v-btn>
  </div>
</template>

<script>
import './LocationEmptyState.scss';

const ICON_NO_LOCATIONS = '/img/icons/fbc-icons/NoCycleAdd.svg';
const ICON_NO_RESULTS = '/img/icons/fbc-icons/NoCycle.svg';

export default {
  name: 'LocationEmptyState',

  props: {
    variant: {
      type: String,
      default: 'no-locations',
      validator: (v) => ['no-locations', 'filters'].includes(v),
    },
    locationHeaderLabel: {
      type: String,
      default: 'Location',
    },
    canAdd: {
      type: Boolean,
      default: false,
    },
    actionDisabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    rootTestId() {
      return this.variant === 'no-locations'
        ? 'setup-location__empty-state'
        : 'setup-location__empty-filters';
    },

    iconSrc() {
      return this.variant === 'no-locations' ? ICON_NO_LOCATIONS : ICON_NO_RESULTS;
    },

    title() {
      if (this.variant === 'no-locations') {
        return `No ${this.locationHeaderLabel}s Yet`;
      }
      return `No ${this.locationHeaderLabel.toLowerCase()}s found`;
    },

    description() {
      if (this.variant === 'no-locations') {
        return `Add your first ${this.locationHeaderLabel.toLowerCase()} to configure countries, types, and optional location-specific thresholds for your organization.`;
      }
      return `No ${this.locationHeaderLabel.toLowerCase()}s match your current filters. Try adjusting your search or clear filters to see all ${this.locationHeaderLabel.toLowerCase()}s.`;
    },

    showAction() {
      if (this.variant === 'no-locations') return this.canAdd;
      return true;
    },

    actionLabel() {
      if (this.variant === 'no-locations') return `Add ${this.locationHeaderLabel}`;
      return 'Clear Filters';
    },

    actionTestId() {
      if (this.variant === 'no-locations') {
        return 'setup-location__empty-add-btn';
      }
      return 'setup-location__empty-clear-filters-btn';
    },
  },
};
</script>
